import EA from '../helpers/init';
import Swiper from 'swiper';

export default EA.Methods.sliderImg = ($this) => {
    const swiperSlides = $this.querySelector('.swiper');

    const breakpoint = window.matchMedia('(min-width: 1001px)');
    let slider;

    const enableSwiper = function() {
        slider = new Swiper(swiperSlides, {
            speed: 600,
            slidesPerView: 'auto',
            spaceBetween: 32,
        });
    };

    const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
            if ( slider !== undefined ) slider.destroy( true, true );
            return;
        } else if ( breakpoint.matches === false ) {
            return enableSwiper();
        }
    };

    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker();


};
